// Globals
import { StyleProvider } from '@ant-design/cssinjs';
import '@ant-design/v5-patch-for-react-19';
import { XProvider } from '@ant-design/x';
import { Spin } from 'antd';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';

// Modules
import { SettingsContainer } from '@/modules/Settings';
import { WidgetContainer } from '@/modules/Widget';

// Helpers
import { loadFont } from '../../helpers';

// Components
import { StylesRootContainer } from './RootContainerStyles';

export const rootContainer = (containerElement: HTMLElement) => {
  loadFont();

  const shadowRoot = containerElement.attachShadow({ mode: 'open' });
  const shadowContainer = document.createElement('div');
  shadowRoot.appendChild(shadowContainer);

  const root = createRoot(shadowContainer);

  root.render(
    <StyleProvider container={shadowRoot}>
      <StyleSheetManager target={shadowRoot}>
        <StylesRootContainer>
          <Suspense fallback={<Spin spinning />}>
            <XProvider theme={{ token: { fontFamily: 'var(--font-family)' } }}>
              <SettingsContainer>
                <WidgetContainer />
              </SettingsContainer>
            </XProvider>
          </Suspense>
        </StylesRootContainer>
      </StyleSheetManager>
    </StyleProvider>
  );
};
